import MockAdapter from 'axios-mock-adapter'
import { cloneDeep } from 'lodash'

function fixture (name) {
  return cloneDeep(require(`./fixtures/${name}.json`))
}

export function mock (instance, options) {
  const _options = Object.assign({}, {
    ...options,
    delayResponse: 500
  }, options)

  const mock = new MockAdapter(instance, _options)

  // user
  // if the user has auth via change the fixture('user') or fixture('noAuth')
  mock
    .onGet('/api/user/details')
    .reply(200, fixture('user'))

  // sign up
  mock
    .onPost('/api/user/signup')
    .reply(200, fixture('signup'))

  // address
  mock
    .onPost('/api/checkout/addresses')
    .reply(200, fixture('address'))

  // post personal form
  mock
    .onPost('/api/checkout/details')
    .reply(200, fixture('personalForm'))

  // footer
  mock
    .onGet('/api/common/links')
    .reply(200, fixture('footer'))

  // product
  mock
    .onGet('/api/bundle/details')
    .reply(200, fixture('product'))

  // paymentMethod
  mock
    .onGet('/api/payment/methods')
    .reply(200, fixture('paymentMethod'))

  // product subscription
  mock
    .onGet('/api/productSubscription')
    .reply(200, fixture('subscription'))

  // product subscription details
  mock
    .onGet(/\/api\/subscription\/.+\/details/)
    .reply(200, fixture('subscriptionDetails'))

  mock
    .onGet('/api/billing')
    .replay(200, fixture('billing'))

  // post product subscription pay in full
  mock
    .onPost(/\/api\/subscriptions\/.+\/payinfull/)
    .reply(200, fixture('subscriptionDetails'))

  // account -- getPaymentMethod
  mock
    .onGet('/api/account/paymentMethod')
    .reply(200, fixture('paymentDetails'))

  // account -- postPaymentMethod
  mock
    .onPost('/api/account/paymentMethod')
    .reply(200, fixture('paymentDetails'))

  mock
    .onGet('/api/test')
    .reply(200, fixture('cartDetails'))
}
